import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DecimalToCommaPipe} from './decimal-to-comma.pipe';
import {CommaToDecimalPipe} from './comma-to-decimal.pipe';
import {ClientCaseIdPipe} from './client-case-id.pipe';
import {OrderPipe} from './order.pipe';
import {NaePipe} from './nae.pipe';
import {MinMaxFilterPipe} from './min-max-filter.pipe';
import {MoneyPipe} from './money.pipe';
import {SafeHtmlPipe} from './safe-html.pipe';
import {UsernamePipe} from './username.pipe';
import {FileSizePipe} from './file-size.pipe';
import {TimePipe} from './time.pipe';

@NgModule({
    declarations: [
        MinMaxFilterPipe,
        DecimalToCommaPipe,
        CommaToDecimalPipe,
        ClientCaseIdPipe,
        OrderPipe,
        NaePipe,
        MoneyPipe,
        SafeHtmlPipe,
        UsernamePipe,
        FileSizePipe,
        TimePipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        MinMaxFilterPipe,
        DecimalToCommaPipe,
        CommaToDecimalPipe,
        ClientCaseIdPipe,
        OrderPipe,
        NaePipe,
        MoneyPipe,
        SafeHtmlPipe,
        UsernamePipe,
        FileSizePipe,
        TimePipe
    ],
    providers: [
        OrderPipe
    ]
})
export class PipesModule {
}
